import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'
import { FeatureToggle } from './featureToggles'

export const insightsPortalAdsDashboardAccessControl: DomainAccessControlConfig = [
  {
    permissions: Permission.InsightsPortalAdsDashboard,
    featureToggles: FeatureToggle.InsightsPortalAdsDashboard,
  },
  {
    permissions: Permission.InsightsPortalAdsDashboard,
    warehouseFeatureToggles: FeatureToggle.InsightsPortalAdsDashboardRetailers,
  },
]

export const insightsPortalAdsDashboardAdsSurfaceFilterAccessControl: DomainAccessControlConfig = {
  featureEntitlementIds: [FeatureEntitlements.AdsSurfaceFilterEntitlement],
}
